import { useHistory } from 'react-router-dom'
import qs from 'querystring'
import { addSearchParams } from 'helpers/common'
import type { IParam } from 'libs/apis'
import type { IParamForSubmit } from 'libs/apis/helper'
import type { IIndexable } from 'helpers/model'

type ReturnedData<T> = [T, (params: IParamForSubmit | T) => void]

const useSearchParams = <T = IParam>(
  defaultParams?: IParamForSubmit & IIndexable,
): ReturnedData<T> => {
  const history = useHistory()

  const getDefaultParams = () => {
    if (!defaultParams) {
      return
    }

    const _defaultParams: IParam = Object.keys(defaultParams).reduce<
      IParam & IIndexable
    >((result, key) => {
      result[key] = `${defaultParams[key]}`
      return result
    }, {})

    return _defaultParams
  }

  const searchParams: IParam = {
    ...getDefaultParams(),
    ...qs.parse(history.location.search.replace('?', '')),
  }

  const setSearchParams = (params: IParamForSubmit | T) => {
    const nextParams = addSearchParams(searchParams, params)
    history.replace({
      pathname: history.location.pathname,
      search: qs.stringify(nextParams),
    })
  }

  return [searchParams as T, setSearchParams]
}

export default useSearchParams
